// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"K2-z","colorTextValue":"L2-z","swatches":"M2-z","collapseLink":"N2-z","isCollapsed":"O2-z","dropdown":"P2-z","disabled":"Q2-z"};